export const initShowMoreGrid = () => {
    const items = document.querySelectorAll('.js-reveal-item');
    const showMoreButton = document.getElementById('show-more-button');
    const showLessButton = document.getElementById('show-less-button');

    let itemsToShow = 6;

    if  (items){
        // Function to show items with animation
        const showItems = (start, end) => {
            for (let i = start; i < end && i < items.length; i++) {
                setTimeout(() => {
                    items[i].style.display = 'flex';
                    items[i].style.flexDirection = 'column';
                    items[i].style.opacity = 0;
                    items[i].style.transition = 'opacity 0.3s';
                    setTimeout(() => {
                        items[i].style.opacity = 1;
                    }, 10);
                }, (i - start) * 100); // Stagger the animation by 100ms
            }
        };

        // Function to hide items with animation
        const hideItems = (start, end) => {
            for (let i = start; i < end && i < items.length; i++) {
                setTimeout(() => {
                    items[i].style.opacity = 0;
                    items[i].style.transition = 'opacity 0.3s';
                    setTimeout(() => {
                        items[i].style.display = 'none';
                    }, 300); // Match the transition duration
                }, (i - start) * 100); // Stagger the animation by 100ms
            }
        };

        // Initial setup: Ensure first 6 items are shown without animation
        for (let i = 0; i < itemsToShow && i < items.length; i++) {
            items[i].style.display = 'flex';
            items[i].style.opacity = 1;
        }

        if (showMoreButton){
            showMoreButton.addEventListener('click', function() {
                showItems(itemsToShow, items.length);
                showMoreButton.style.display = 'none';
                showLessButton.style.display = 'flex';
            });
        }

        if  (showLessButton){
            showLessButton.addEventListener('click', function() {
                hideItems(itemsToShow, items.length);
                showMoreButton.style.display = 'flex';
                showLessButton.style.display = 'none';
            });
        }
    }
};
